module.exports = __webpack_public_path__ + "img/010-toothbrush.d911562f.svg";